import React from "react";

import { CustomersReportFilter } from "./CustomersReportFilter";
import { CustomersReportSummary } from "./CustomersReportSummary";
import { CustomersReportTable } from "./CustomersReportTable";

export function CustomersReport() {
  return (
    <div className="flex w-full flex-col gap-5 pt-5">
      <CustomersReportFilter />
      <CustomersReportSummary />
      <CustomersReportTable />
    </div>
  );
}
